export const CouponConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider.state('app.couponlisting', {
    url: '^/coupons',
    template: '<coupons-listing></coupons-listing>'
  });
  $stateProvider.state('app.couponAdd', {
    url: '^/coupons/add',
    template: '<coupons-add></coupons-add>'
  });
  $stateProvider.state('app.couponEdit', {
    url: '^/coupons/edit/:id',
    template: '<coupons-edit></coupons-edit>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/components/coupon.config.js
 **/